/**
 * Extract initials from a full name
 * @param name - Full name (e.g., "Brandon Lee")
 * @returns Initials (e.g., "BL")
 */
export const getInitials = (name: string): string => {
  if (!name) {
return '??';
}

  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

/**
 * Format date to relative time (e.g., "2 days ago", "Mar 11")
 * @param dateString - ISO date string
 * @returns Formatted date string
 */
export const formatRelativeDate = (dateString: string): string => {
  if (!dateString) {
return '';
}

  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
return 'Today';
}
  if (diffInDays === 1) {
return 'Yesterday';
}
  if (diffInDays < 7) {
return `${diffInDays} days ago`;
}
  if (diffInDays < 30) {
return `${Math.floor(diffInDays / 7)} weeks ago`;
}

  // Return formatted date for older dates
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

/**
 * Format date/time as "M/DD/YY h:mm AM/PM"
 * @param dateString - ISO date string
 * @returns Formatted date/time string (e.g., "10/13/25 4:02 PM")
 */
export const formatDateTime = (dateString: string): string => {
  if (!dateString) {
return '';
}

  const date = new Date(dateString);

  // Get date components
  const month = date.getMonth() + 1; // 0-indexed, so add 1
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2); // Last 2 digits

  // Get time components
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12

  // Format with leading zeros for minutes
  const minutesStr = minutes.toString().padStart(2, '0');

  return `${month}/${day}/${year} ${hours}:${minutesStr} ${ampm}`;
};
